{
  "general.success": "Success",
  "site_dev_command_def.description": "Open the Local Editor that runs your local code",
  "site_preview_command_def.description": "Create a shareable version of your site before going live",
  "site_preview_command_def.option.force": "Skip build errors and proceed with the operation",
  "site_publish_command_def.description": "Publish your site to production",
  "site_publish_command_def.option.force": "Skip build errors and proceed with the operation",
  "site_publish_command_def.option.approve_preview": "Approve preview automatically",
  "site_install_command_def.description": "Install a supported NPM package",
  "site_install_command_def.argument.package": "npm package name",
  "site_uninstall_command_def.description": "Uninstall an NPM package",
  "site_uninstall_command_def.argument.package": "npm package name",
  "site_dev_command_def.option.tunnel": "Open a HTTPS tunnel for the local dev server",
  "dev_command.dev_environment.loading": "Starting dev environment...",
  "dev_command.dev_environment.success": "Development environment ready",
  "dev_command.no_open_editor": "There is no Local Editor tab open. Press <0/> to open a new Local Editor instance",
  "dev_command.sync_changes.loading": "Syncing local files...",
  "dev_command.sync_changes.success": "Local files have been synced",
  "preview_command.loading": "Creating preview deployment...",
  "preview_command.success": "Your preview deployment is now available at <0/>",
  "publish_command.preview.loading": "Creating preview deployment...",
  "publish_command.preview.warning": "Build failed with code errors that will impact your published version.",
  "publish_command.preview.success": "Your preview deployment is now available at <0/>",
  "publish_command.confirm_publish": "Continue with publish?",
  "publish_command.publish.loading": "Publishing your site...",
  "publish_command.publish.success": "Your site has been published successfully: <0/>",
  "install_command.package.loading": "Installing <0>{packageName}</0>...",
  "install_command.package.success": "<0>{packageName}</0> was successfully installed.",
  "install_command.all_packages.loading": "Installing dependencies...",
  "install_command.all_packages.success": "Dependencies were successfully installed.",
  "uninstall_command.loading": "Uninstalling <0>{packageName}</0>...",
  "uninstall_command.success": "<0>{packageName}</0> successfully uninstalled."
}
